import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  > :first-child {
    max-width: 300px;
    width: 300px;

    @media (max-width: ${windowWidth.mobile.large}) {
      max-width: unset;
      width: unset;
    }
  }
`;

const RolesBoard = styled.div`
  width: 100%;
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  overflow-y: scroll;
  padding-bottom: 102px;
`;

const NoRecordsFound = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
  font-size: 14px;
  color: #888888;
`;

export { Container, RolesBoard, NoRecordsFound };